/**
 * Which links in a Copilot answer may be shown as links (LP-443). A draft's href and a quote card's
 * editor link come back in the chat answer, which the model can influence, and they are rendered as
 * router Links (src/components/CopilotQuoteCard.jsx DraftLink and QuoteCard; CopilotPanel and
 * CopilotDock show drafts through DraftLink). Only a path on this origin links: one "/" then printable
 * ASCII path characters. A scheme (javascript:, data:), "//host", "https://host", a backslash,
 * whitespace or a control character, the same in percent-encoded form, or dot segments that leave a
 * "//" path all give null, and the caller shows the label as plain text.
 * Imported by the browser bundle: plain functions, no Node imports.
 */

const MAX = 2048;
// Raw: starts with "/", then unreserved, sub-delims, ":", "@", "/", "?", "#" or a %XX escape.
const RAW = /^\/(?:[A-Za-z0-9\-._~!$&'()*+,;=:@/?#]|%[0-9A-Fa-f]{2})*$/;
// Never in a portal path, raw or decoded: backslash, whitespace, control and format characters.
const BAD = /[\\\s\p{Cc}\p{Cf}]/u;
const BASE = 'https://portal.invalid';

/** One form of the href (raw or decoded): a path that stays on this origin. */
function onOrigin(s) {
  if (s[0] !== '/' || s[1] === '/' || s[1] === '\\' || BAD.test(s)) return false;
  let u;
  try { u = new URL(s, BASE); } catch { return false; }
  // "/..//host" and "/%2e%2e//host" resolve to the path "//host", which a later navigation can read as a host.
  return u.origin === BASE && !u.pathname.startsWith('//');
}

/** The href when it is a same-origin portal path, else null. Every decoding of it must be one too. */
export function safeHref(href) {
  if (typeof href !== 'string' || !href || href.length > MAX || !RAW.test(href)) return null;
  let s = href;
  for (let i = 0; i < 4; i += 1) {
    if (!onOrigin(s)) return null;
    let d;
    try { d = decodeURIComponent(s); } catch { return null; }
    if (d === s) return href;
    s = d;
  }
  return null; // still decoding after four rounds: not a portal link
}
